module.exports = __webpack_public_path__ + "static/media/resourcesMessaging.44604175.png";